import React from "react";
import { Link } from "react-router-dom";
import { setPath } from "../lib/slug";

/** Set tile in the sets grid.
 *
 * Layout (owner directive 2026-02-01):
 *   [logo (R2 only — never hotlink tcgdex)]
 *   [set name  (left) ................  meta (right, one row)]
 *
 * Logo images are served EXCLUSIVELY from the R2 public base
 * (`media.cardcapture.show`) via `set.logo_url`. When uncached, we render
 * a text placeholder (never a broken image, never `assets.tcgdex.net`).
 */
export default function SetCard({ set }) {
  const dateLabel = set.release_date
    ? new Date(set.release_date + "T00:00:00Z").toLocaleDateString(undefined, {
        year: "numeric",
        month: "short",
        day: "numeric",
      })
    : null;
  const countLabel =
    typeof set.card_count === "number" ? `${set.card_count} cards` : null;
  const metaParts = [countLabel, dateLabel].filter(Boolean);
  const metaLabel = metaParts.length ? metaParts.join(" \u00b7 ") : "\u2014";

  return (
    <Link
      to={setPath("pokemon", "en", set.name || set.external_id)}
      data-testid={`set-card-${set.external_id}`}
      className="animate-rise group flex flex-col rounded-card border border-ink-chip bg-ink-surface p-4 transition-colors duration-cc ease-cc-ease hover:border-ink-muted"
    >
      <div
        className="cc-card-plate mb-4 flex items-center justify-center rounded-card"
        style={{ aspectRatio: "16 / 9" }}
        data-testid={`set-card-logo-${set.external_id}`}
      >
        {set.logo_url ? (
          <img
            src={set.logo_url}
            alt={`${set.name} logo`}
            className="max-h-[70%] max-w-[70%] object-contain"
            loading="lazy"
            data-testid={`set-card-logo-img-${set.external_id}`}
          />
        ) : (
          <span
            className="text-eyebrow text-ink-muted uppercase"
            data-testid={`set-card-logo-placeholder-${set.external_id}`}
          >
            {set.code || set.external_id}
          </span>
        )}
      </div>

      <div className="flex flex-1 items-baseline justify-between gap-3">
        <div
          className="text-card-name text-ink-text truncate"
          data-testid={`set-card-name-${set.external_id}`}
          title={set.name}
        >
          {set.name}
        </div>
        <div
          className="shrink-0 text-meta text-ink-muted tabular whitespace-nowrap"
          data-testid={`set-card-meta-${set.external_id}`}
        >
          {metaLabel}
        </div>
      </div>
    </Link>
  );
}
